// Helper to only do something in dev environments. Use cases could include showing error messages to engineers

import isTest from "./isTest";

export const isDev =
  isTest ||
  process.env.NODE_ENV === "development" ||
  process.env.BREX_ENV !== "production";
